// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mtu4","title":"styles_title__2MZEH"};